const FIInformation = {
  FI_NAME: "DXM Financial",
  FI_EMAIL: "mailto:someone@yoursite.com?subject=Mail from Our Site",
  FI_TERMS: "https://www.doxim.com/terms-of-use/",
};

export default FIInformation;
